import { NgModule } from '@angular/core';
import { ApxInputDirective } from './input.directive';
import { ApxInputGroupComponent } from './input-group/input-group.component';
import { ApxSuffixDirective } from './directives/apx-suffix.directive';
import { ApxPrefixDirective } from './directives/apx-prefix.directive';

const exportedComponents = [ApxInputDirective, ApxInputGroupComponent, ApxPrefixDirective, ApxSuffixDirective];

@NgModule({
    imports: [...exportedComponents],
    exports: exportedComponents
})
export class ApxInputModule {}

// Re-export components for barrel exports
export { ApxInputDirective } from './input.directive';
export { ApxInputGroupComponent } from './input-group/input-group.component';
export { ApxSuffixDirective } from './directives/apx-suffix.directive';
export { ApxPrefixDirective } from './directives/apx-prefix.directive';
